import React from 'react';
import { MapPin, Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../../../../assets/css/subscreens/customer/dashboard/apphome/appherosection/AppHeroSection.css';

const PromoHero = ({ onClick }) => {
  const navigate = useNavigate();
  return (
    <div className="pph-wrap">
      <div className="ph-banner" onClick={onClick}>

        {/* Subscription badge — top right */}
        <button
          className="ph-sub-btn"
          onClick={(e) => { e.stopPropagation(); navigate('/customer-subscription'); }}
          aria-label="Go Pro"
        >
          <Crown size={13} className="ph-sub-btn__icon" />
          <span className="ph-sub-btn__label">Go Pro</span>
          <span className="ph-sub-btn__pill">✦</span>
        </button>

        {/* Background worker image */}
        <div className="ph-bg-img">
          <img
            src="https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=600&q=80"
            alt="worker"
          />
        </div>

        {/* Content */}
        <div className="ph-content">
          <span className="ph-eyebrow">
            <MapPin size={13} /> USA's #1 Home Services
          </span>
          <h2 className="ph-headline">
            Trusted Experts<br />At Your Door
          </h2>
          <p className="ph-sub">
            Verified professionals for every home need — booked in minutes, done right.
          </p>
          <button
            className="ph-btn"
            onClick={(e) => { e.stopPropagation(); navigate('/post-a-job'); }}
          >
            Post a Job
          </button>
        </div>

      </div>
      {/* ── Go Premium Banner ── */}

    </div>
    
  );
};

export default PromoHero;